enum DeliveryMethod {
	OnSiteAndTelehealth = 1,
	OnsiteOnly = 2,
	TelehealthOnly = 3,
}

export default DeliveryMethod;
